window.dtDepartmentTransfer = function () {
  const dt_department_transfer = new DataTable('#department-transfer-datatable', {
    processing: false,
    serverSide: true,
    responsive: true,
    ajax: {
      url: $('#department-transfer-datatable').data('source'),
      beforeSend: function () { showLoadingRow('#department-transfer-datatable', 9); },
      complete: function () { hideLoadingRow(); }
    },
    pagingType: "full_numbers",
    order: [[2, 'desc']],
    columns: [
      { "data": "index" },
      { "data": "status" },
      { "data": "date" },
      { "data": "code" },
      { "data": "employee_fn" },
      { "data": "employee_ln" },
      { "data": "old_department" },
      { "data": "new_department" },
    ],
    columnDefs: [],
    language: {
      search: ' ',
      sLengthMenu: '_MENU_',
      searchPlaceholder: "Search...",
      info: "Showing _START_ to _END_ of _TOTAL_ entries"
    },
    rowCallback: function (row, data, index) {
      $('td', row).addClass('py-1');
      $('td:eq(4)', row).html(`${data.employee_fn} ${data.employee_ln}`);
      $('td:eq(4)', row).attr('colspan', 2);
      $('td:eq(5)', row).remove()
    },
  });

  dtFinalTouch()
}